<template>
  <el-dialog title="校准金额" :visible="visible" width="520px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="收款姓名:">
        <el-input disabled v-model.trim="form.account_name" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="收款账号:">
        <el-input disabled v-model.trim="form.account_number" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="当前余额:">
        <el-input disabled v-model.trim="form.sj_amount_to" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="校准金额:" prop="money">
        <el-input clearable :maxlength="20" v-model.trim="form.money" placeholder="请输入"
          @input="filterNonNumericInput" />
      </el-form-item>
      <el-form-item label="校准原因:" prop="remark">
        <el-input clearable :maxlength="300" v-model.trim="form.remark" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecolumnEditTo',
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: {
        money: '',
        remark: '',
      },
      rules: {
        money: [{ required: true, message: '请输入', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val && this.data) {
        this.form = Object.assign({ money: '', remark: '' }, this.data);
      }
    },
    data() {
      if (this.visible && this.data) {
        this.form = Object.assign({ money: '', remark: '' }, this.data);
      }
    },
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http.post('/resourcecolumn/jaoyanBalance', {
          id: this.form.id,
          money: this.form.money,
          remark: this.form.remark,
        }).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    filterNonNumericInput() {
      this.form.money = this.form.money.replace(/\D/g, '');
    },
  },
};
</script>
